import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { Actuator } from '../actuator';
@Component({
    selector: 'onoff',
    templateUrl: 'onoff.component.html',
    styleUrls: ['./onoff.component.scss'],
    encapsulation: ViewEncapsulation.Emulated,
})
export class OnOffComponent implements OnInit {
    @Input() actuator: Actuator;
    @Output() changeActuator = new EventEmitter<any>();
    constructor() { }

    ngOnInit() { 
    }
}